import React from 'react'
import Button from '../../artzu-ui/src/Button'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';

const MobileAppBanner = ({ os, closeBanner }) => {
  return (
    <div className="mobile-app-banner">
      <a className="mobile-app-close" onClick={closeBanner}><FontAwesomeIcon icon={faTimes} style={{width: "16px", height: "16px", color: "white"}} /></a>
      <a className="mobile-app-link" href={
        ["iOS"].includes(os) ? "https://apps.apple.com/us/app/autzu/id1486349150?mt=8" :
          "https://play.google.com/store/apps/details?id=com.autzu.autzuAndroid&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
      }>
        <h5>App is now available</h5>
        <Button label="Get App" className="get-app-button" padding="0" />
      </a>
    </div>
  )
}

export default MobileAppBanner


// WEBPACK FOOTER //
// ./src/components/Layout/MobileAppBanner.js